import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherIcon from "./WeatherIcon";
import WeatherTempUnit from "./WeatherTempUnit";

export default function WeatherInfo(props) {
    return ( 
    <div className="WeatherInfo">
    <h1>{props.data.city}</h1>
<ul>
<li>
<FormattedDate date={props.data.date}/>

</li>
<li className="text-capitalize">{props.data.condition}</li>

</ul>
<div className="row mt-3">
<div className="col-6">
<div className="clearfix" >  

<div className="weather-temp-container">
  <img
    src={props.data.iconUrl}
    alt={props.data.icon}
    className="weather-icon"
  />
  <WeatherTempUnit celsius={props.data.temperature.current} />
  <WeatherIcon code={props.data.condition.icon_url} size={64}/>
</div>
</div>
</div>


<div className="col-6">
<ul>
    <li>Humidity : {props.data.humidity}%</li>
    <li>Wind : {props.data.wind}k/h</li>
</ul>

</div>




</div>
  </div>  );

}